import React, {useState} from "react";
import {compose} from "redux";
import withAPI from "../../../services/api";
import ClosePopupBtn from "../../UtilComps/ClosePopupBtn";

const SuperAdminSchoolDeleteModal = ({
  api,
  superAdminSchoolId,
  refreshList,
  shouldShowFunc,
}) => {
  const [error, setError] = useState("");

  return (
    <div className='pdf-upload'>
      <div className='pdf-upload-wrapper'>
        <div className='common_border'>
          <div className='common_heading'>
            <p>Remove School</p>
            <ClosePopupBtn closePopupFunc={shouldShowFunc} />
          </div>

          <div className='common_dashboard_bg'>
            <div className='row'>
              <div className='col-12'>
                {error && (
                  <div>
                    <div className='alert alert-danger'>{error.toString()}</div>
                    <div className='d-flex'>
                      <button
                        onClick={() => {
                          shouldShowFunc(false);
                        }}
                        className='btn btn-sm btn-primary'
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                )}

                {!error && (
                  <div>
                    <p>
                      Are you sure you want to delete this school? This action
                      cannot be reversed.
                    </p>
                    <div className='d-flex'>
                      <button
                        onClick={() => {
                          setError("");
                          api
                            .deleteSuperAdminSchool(superAdminSchoolId)
                            .then(() => {
                              refreshList();
                              shouldShowFunc(false);
                            })
                            .catch((e) => {
                              console.log("Caught error deleting School:", e);
                              setError(e);
                            });
                        }}
                        className='btn btn-sm btn-danger'
                      >
                        Yes, Remove School
                      </button>
                      <button
                        onClick={() => {
                          shouldShowFunc(false);
                        }}
                        className='btn btn-sm btn-primary ml-4'
                      >
                        No, take me back
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(withAPI)(SuperAdminSchoolDeleteModal);
